// extracted by mini-css-extract-plugin
export var blockGrid = "blockGrid-module--block-grid--992d7";
export var blockGridContent = "blockGrid-module--block-grid-content--c7220";
export var blockGridImage = "blockGrid-module--block-grid-image--57c13";
export var blockGridItem = "blockGrid-module--block-grid-item--b2409";
export var blockGridText = "blockGrid-module--block-grid-text--47f79";
export var blockGridWrapper = "blockGrid-module--block-grid-wrapper--e702d";